import {useTranslation} from "react-i18next";
import {Card, CardContent, CardHeader, Chip, Grid, Link, Stack, Typography, useTheme} from "@mui/material";
import React from "react";
import PropTypes from "prop-types";

InfoLabel.propTypes = {
    label: PropTypes.shape({
        collectionId: PropTypes.number,
        color: PropTypes.string,
        description: PropTypes.string,
        label: PropTypes.string,
        altoType: PropTypes.string,
        type: PropTypes.string,
        uri: PropTypes.string
    })
}

export default function InfoLabel(props) {
    const {label} = props;
    const {t} = useTranslation('common');
    const theme = useTheme();

    if (label)
        return (
            <Card variant="outlined">
                <CardHeader title={label.label} subheader={label.description} sx={{maxWidth: "400px"}}/>
                <CardContent sx={{minWidth: "200px", maxWidth: "fit-content"}}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Typography variant="caption">ID:</Typography>
                                <Typography variant="body2">{label.id}</Typography>
                            </Stack>
                        </Grid>
                        <Grid item xs={12}>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Typography variant="caption">
                                    URL:
                                </Typography>
                                <Link color="inherit" href={label.uri} target="_blank" rel="noopener">
                                    <Typography>{label.uri}</Typography>
                                </Link>
                            </Stack>
                        </Grid>
                        <Grid item xs={12}>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Typography variant="caption">Type:</Typography>
                                <Typography variant="body2">{label.type}</Typography>
                            </Stack>
                        </Grid>
                        <Grid item xs={12}>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Typography variant="caption">AltoType:</Typography>
                                <Chip label={label.altoType} variant="outlined"/>
                            </Stack>
                        </Grid>
                        <Grid item xs={12}>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Typography variant="caption">
                                    {t("main.pages.profile.annotation.card.creation.color")}:
                                </Typography>
                                <Chip
                                    label={label.color}
                                    sx={{
                                        color: theme.palette.getContrastText(label.color),
                                        bgcolor: label.color,
                                    }}/>
                            </Stack>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        );
    return null;
}